export default __webpack_public_path__ + "static/media/screenBlock6.08d9de0d.jpg";